<div class="custom-mat-form-wrapper" [class.compact-field]="compact">
  @if (searchLabel) {
    <div class="mat-form-label">{{ searchLabel }}</div>
  }
  <mat-form-field appearance="fill" class="size-{{ sizeSearchFiled }} {{ searchFieldClasses }}">
    <input [placeholder]="searchPlaceholder" autocomplete="off" matInput id="searchInput" [formControl]="searchCtrl" />
    <div matPrefix>
      <dojo-icon [icon]="'search'" [iconClass]="'text-primary'" />
    </div>
    <div matSuffix [style.visibility]="searchCtrl.value ? 'visible' : 'hidden'">
      <button mat-icon-button (click)="searchCtrl.reset('')" data-test="list-view-input-search-entity-clear-search">
        <dojo-icon [icon]="'times'" [size]="16" [iconClass]="'text-primary'" />
      </button>
    </div>
  </mat-form-field>
</div>
